import { render, staticRenderFns } from "./gHead.vue?vue&type=template&id=4a4c2e02&scoped=true&"
import script from "./gHead.vue?vue&type=script&lang=js&"
export * from "./gHead.vue?vue&type=script&lang=js&"
import style0 from "./gHead.vue?vue&type=style&index=0&id=4a4c2e02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4c2e02",
  null
  
)

export default component.exports